export default "__VITE_PUBLIC_ASSET__c6ab72f2__"